import axios from 'axios'
import { Toast ,Dialog } from 'mand-mobile';
import md5 from 'js-md5';
import store from '@/store'
import { getToken,removeToken,removeType } from '@/utils/auth'

// 创建axios实例
// axios.defaults.baseURL = "http://api-np-dev.hzhhkeji.com/" // api 的 base_url
axios.defaults.baseURL = process.env.VUE_APP_BASE_API // api 的 base_url
axios.defaults.timeout = 10000 // 请求超时时间
axios.defaults.withCredentials = true;

// request拦截器
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    config.headers["Content-Type"] = 'application/x-www-form-urlencoded; charset=UTF-8';
    config.headers["device"] = md5('pos')
    // config.headers["Access-Control-Allow-Origin"] = '*';
    if(getToken()){
      config.headers["x-api-key"] = getToken();
    }
    return config
  },
  error => {
    // 请求出现错误
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// respone拦截器
axios.interceptors.response.use(
  /**
  * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
  * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
  */
  response => {
    const res = response.data
    if (res.code != 200) {
      // -1：操作异常   401：未认证未登录   403：暂无权限
      if (res.code == 401) {
        // 未登录 去登陆
        removeToken()
        removeType()
        Dialog.confirm({
          title: '提示',
          content: '您已经登出，您可以取消以停留在此页面，或再次登录',
          confirmText: '确定',
          onConfirm: () => {
            location.reload()
          },
        })
      }else if(res.code == 405){
        removeToken()
        removeType()
        // 提示操作异常
        Toast.info("权限不足，即将退出！");
        setTimeout(()=>{
          location.reload()
        },3000)
      }else{
        // 提示操作异常
        Toast.info(res.message);
      }
      return Promise.reject(res || '错误')
    } else {
      return Promise.resolve(res)
    }
  },
  error => {
    if (error.response) {
      
    } else if (error.request) {
      
    } else {
      Toast.failed("请求错误");
    }
    return Promise.reject(error)
  }
) 


const service = ({
  url,
  method,
  data,
  isUplaod
} = {}) => {
  var params = new URLSearchParams()
  if(isUplaod){
    params= data
  }else{
    for (const i in data) {
      params.append(i, data[i])
    }
  }
  return new Promise((resolve, reject) => {
    if(!navigator.onLine){
      Toast.failed("请先连接网络！")
      reject(err)
    }
    const fromdata = {
      url,
      method: method || 'post'
    }
    if (method.toLowerCase() === 'get') {
      fromdata.params = params
    } else {
      fromdata.data = params
    }
    axios(fromdata).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
export default service
